import { useAtomValue } from "jotai";
import { CartFill } from "react-bootstrap-icons";
import { groupParkerCartBannerAtom } from "../Data/Atoms";
import { cents, showMoney } from "../Data/Money";

const GRADIENT = "linear-gradient(135deg, #e8359a 0%, #c0116e 100%)";

export function GroupParkerCheckoutBanner() {
    const cart = useAtomValue(groupParkerCartBannerAtom);
    if (!cart || cart.pendingCount <= 0) return null;

    return (
        <div className="group-parker-checkout-banner-wrap">
            <div
                className="group-parker-checkout-banner"
                style={{ background: GRADIENT, color: "#fff", width: "100%" }}
            >
                <div className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center justify-content-md-between gap-3 px-3 px-md-4 py-3">
                    <div className="d-flex align-items-center gap-2 min-w-0">
                        <div
                            className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                            style={{ width: 36, height: 36, backgroundColor: "rgba(255,255,255,0.2)" }}
                        >
                            <CartFill size={18} />
                        </div>
                        <div className="min-w-0">
                            <div className="small text-uppercase fw-semibold" style={{ opacity: 0.85, letterSpacing: "0.04em" }}>
                                Ready to Checkout
                            </div>
                            <div className="fw-bold fs-5 text-truncate">
                                {cart.pendingCount} parker{cart.pendingCount !== 1 ? "s" : ""} · {showMoney(cents(cart.dueToday))}
                                {!cart.isAccountsReceivable ? "*" : ""}
                                {cart.isAccountsReceivable ? " invoiced" : " due today"}
                            </div>
                            {!cart.isAccountsReceivable && (
                                <div className="small" style={{ opacity: 0.75 }}>
                                    *Does not include applicable fees
                                </div>
                            )}
                            {cart.canAssignMore && (
                                <div className="small" style={{ opacity: 0.85 }}>
                                    Assign more open spots before checkout
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="d-flex gap-2 flex-shrink-0 w-100 w-md-auto">
                        <button
                            type="button"
                            className="btn rounded-pill px-3 py-2 flex-fill flex-md-grow-0"
                            style={{
                                backgroundColor: "rgba(255,255,255,0.12)",
                                color: "rgba(255,255,255,0.9)",
                                fontSize: "0.85rem",
                                border: "1px solid rgba(255,255,255,0.25)",
                            }}
                            onClick={cart.onClearCart}
                        >
                            Clear cart
                        </button>
                        {cart.canAssignMore && (
                            <button
                                type="button"
                                className="btn fw-semibold rounded-pill px-3 py-2 flex-fill flex-md-grow-0"
                                style={{ backgroundColor: "rgba(255,255,255,0.15)", color: "#fff", fontSize: "0.9rem", border: "1px solid rgba(255,255,255,0.35)" }}
                                onClick={cart.onAssignAnother}
                            >
                                Assign Another
                            </button>
                        )}
                        <button
                            type="button"
                            className="btn fw-semibold rounded-pill px-3 py-2 flex-fill flex-md-grow-0"
                            style={{ backgroundColor: "#fff", color: "#a00d5a", fontSize: "0.9rem" }}
                            onClick={cart.onCheckout}
                        >
                            Checkout
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
